// extracted by mini-css-extract-plugin
module.exports = {"encyclopedia-nav":"EncyclopediaNav_encyclopedia-nav___cjir","breadcrumbs":"EncyclopediaNav_breadcrumbs__zYkPM","search":"EncyclopediaNav_search__kARqf"};